import { render, staticRenderFns } from "./CheckpointAnswerScene.vue?vue&type=template&id=ebb376a0&scoped=true&"
import script from "./CheckpointAnswerScene.vue?vue&type=script&lang=js&"
export * from "./CheckpointAnswerScene.vue?vue&type=script&lang=js&"
import style0 from "./CheckpointAnswerScene.vue?vue&type=style&index=0&id=ebb376a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb376a0",
  null
  
)

export default component.exports